// extracted by mini-css-extract-plugin
export var body = "_co-8";
export var button = "_co-0";
export var closeButton = "_co-5";
export var content = "_co-3";
export var empty = "_co-f";
export var grid = "_co-c";
export var header = "_co-4";
export var icon = "_co-1";
export var option = "_co-d";
export var optionSelected = "_co-e";
export var overlay = "_co-2";
export var searchIcon = "_co-a";
export var searchInput = "_co-b";
export var searchWrapper = "_co-9";
export var title = "_co-6";
export var visuallyHidden = "_co-7";